const lang = {
  page_title: 'プロジェクト',
  breadcrumb: {
    list: 'プロジェクト一覧',
    detail: 'プロジェクト詳細',
    simulation: 'シミュレーション',
  },
  button: {
    add: '＋ プロジェクトを追加する',
    show_expired_organization: '契約終了した団体も表示する',
    delete: '削除',
    add_account: '＋アカウント追加',
  },
  no_data_message: '該当のプロジェクトがありません。',
  pre_project_table: {
    table_name: '登録前プロジェクト',
    project_name: 'プロジェクト名',
    created_at: '作成日',
    monitoring_setting: 'モニタリング設定',
    project_plan: 'プロジェクト計画書',
    forest_running_planning_certified_document: '森林経営計画認定書',
    forest_management_plan: '森林経営計画（全体）',
    fcs_yield_table: '林分収穫表',
    sustainability_confirmation: '永続性確認覚書',
    meeting_record: '説明会等の実施記録',
    contract_documents: '森林施業に関する受委託契約等が確認できる書類',
    forest_book: '森林簿',
  },
  registered_project_table: {
    table_name: '登録済プロジェクト',
    project_name: 'プロジェクト名',
    project_start_date: 'プロジェクト開始日',
    project_end_date: 'プロジェクト終了日',
    protection_status: '保護の実施',
    monitoring_certified: 'モニタリング認定',
    area_ha: '面積（ha）',
    total_co2_absorption_estimate: '総CO2吸収量見込（t-CO2）',
  },
  finished_project_table: {
    table_name: '終了プロジェクト',
    project_name: 'プロジェクト名',
    project_start_date: 'プロジェクト開始日',
    project_end_date: 'プロジェクト終了日',
    area_ha: '面積（ha）',
    total_co2_absorption_estimate: '総CO2吸収量見込（t-CO2）',
  },
  document_table: {
    area_evidence: '面積の根拠資料',
    position_evidence: '地位の根拠資料',
    monitoring_plot_map: 'モニタリングプロット地図',
    other_documents: 'その他',
  },
  create_project_modal: {
    title: 'プロジェクトの追加',
    project_name: 'プロジェクト名',
    project_registration_place: 'プロジェクト登録地',
    registration_place: '登録地',
    delete: '削除',
    forest_management_plan: '森林経営計画',
    no_forest_management_plan: '森林経営計画が作成されていません',
    no_fcs_yield_table: '林分収穫表が作成されていません',
    please_select: '選択してください',
    select_fcs_yield_table: '林分収穫表の選択',
    prefecture_yield_table: '都道府県の林分収穫表',
    organization_yield_table: '団体の林分収穫表',
    prefecture: '都道府県',
    select_prefecture_yield_table: '都道府県を選択後に選択できます',
    area_scope: '全体or一部',
    registration_place_add: '+  登録地を追加する',
    add_plus: '+ 追加する',
    registration_area: '登録地の範囲',
    all: '全部',
    part: '一部',
    select_arrow: '選択する →',
    registered_area: '登録面積（ha）',
  },
  preview_yield_table_modal: {
    title: 'プロジェクトの追加',
    yield_table_name: '林分収穫表名',
    update_and_return: '更新して戻る',
    forest_management_plan: '森林経営計画',
    select_fcs_yield_table: '林分収穫表の選択',
    area_scope: '全体or一部',
    registration_place_add: '＋  登録地を追加する',
  },
  select_registration_place_modal: {
    title: 'プロジェクト登録地の一部選択',
    search_form_title: '林地の検索',
    deselect_all_check_box: 'すべて解除',
    select_all_check_box: 'すべて選択',
    clear: 'クリア',
    search: '検索する',
  },
  simulation: {
    title: 'シミュレーション',
    total_sales: '累計売上高',
    total_profit: '累計利益',
    total_co2_absorption: '累計CO2吸収量',
    break_even_point_sales: '損益分岐点売上高',
    break_even_point_j_credit_price: '損益分岐点Jクレジット価格',
  },
  delete_modal: {
    title: 'プロジェクトの削除',
    explain:
      'プロジェクトに紐づいてシミュレーションが作成されていた場合、プロジェクトの削除はできません。プロジェクトに紐づいていないことを確認して削除してください。',
  },
  document_management: '書類管理',
  export_all_documents: '全書類を出力する',
  complete_registration: '登録の完了',
  registration_notice:
    'J-クレジット制度事務局によって登録が認証されたら、以下のボタンよりプロジェクトの登録を行なってください（登録証が必要です）',
  select_simulation: 'シミュレーションを選択する',
  delete: 'プロジェクトを削除する',
  update_and_return: '更新して戻る',
  done: '済',
  details: '詳細',
  not_done: '未',
}

export default lang
